module.exports = __webpack_public_path__ + "public/img/ico-status-battery.bf75078f.svg";